export default __webpack_public_path__ + "static/media/card2.fe524c64.png";